import { withLocalize } from "react-localize-redux";
import translations from "../../translations/verify.json";
import signupTranslations from "../../translations/signup.json";
import claimFlowTranslations from "../../translations/claimFlow.json";
import "../../styles/credential/credentialWeb.scss";
import { useHistory } from "react-router-dom";
import {
	CampaignDescriptionBlock,
	CampaignDetailBlock,
	CampaignMainInfoCard,
	CampaignMediaActionRow,
	CredentialEarningCriteriaBlock,
	CredentialRatingEnrollmentBlock,
	CredentialSkillsBlock,
	CredentialSupportingDocumentationsBlock,
} from "wallet-elementkit/dist/components";
import mixpanel from "mixpanel-browser";
import { OptimizedMixPanel } from "wallet-elementkit/dist/services";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { selectUser } from "../../store/features/user";

const CredentialWeb = (props) => {
	props.addTranslation(signupTranslations);
	props.addTranslation(translations);
	props.addTranslation(claimFlowTranslations);
	const dispatch = useAppDispatch();

	const userMeta = useAppSelector(selectUser);
	const optimizedMixpanel = new OptimizedMixPanel(mixpanel);

	const history = useHistory();

	return (
		<div>
			<div id="credential-web" className="flex-column">
				<div className="verify-web-inner">
					<CampaignMainInfoCard
						{...props}
						isMobile={false}
						navigateToIssuerProfile={() => {
							optimizedMixpanel?.track("Visit Issuer Profile", {
								credential_no: props.credNo,
								isLogged: userMeta.logged,
								issuer_id: props.campaign?.organization.id,
							});
							window.open(
								window.location.origin +
									`/${
										props.activeLanguage
											? props.activeLanguage.code
											: process.env.REACT_APP_DEFAULT_LANGUAGE ?? "en"
									}/issuer-profile/${props.campaign?.organization.id}/`,
								"_blank"
							);
						}}
						navigateToPathway={(pathwayId) => {
							history.push(
								`/${
									props.activeLanguage
										? props.activeLanguage.code
										: process.env.REACT_APP_DEFAULT_LANGUAGE ?? "en"
								}/pathway/${pathwayId}/`
							);
						}}
					/>
					<CampaignMediaActionRow
						{...props}
						dispatch={dispatch}
						historyPush={history.push}
						isMobile={false}
						mixPanel={mixpanel}
					/>
					<CampaignDetailBlock {...props} />

					<div className="verify-inner-details">
						{!props.loading && (
							<CampaignDescriptionBlock
								description={props.campaign?.detail.description}
								{...props}
							/>
						)}
						{!props.loading &&
							props.campaign?.detail.skills &&
							props.campaign?.detail.skills.length > 0 && (
								<CredentialSkillsBlock
									navigateToSkillPage={(skillId) => {
										history.push(
											`/${
												props.activeLanguage
													? props.activeLanguage.code
													: process.env.REACT_APP_DEFAULT_LANGUAGE ?? "en"
											}/skill/${skillId}/`
										);
									}}
									{...props}
									skills={props.campaign?.detail.skills.map((skill) => ({
										...skill,
										id: 1212,
									}))}
								/>
							)}
						{!props.loading &&
							props.attendeeCount > 0 &&
							props.courseRatingCount > 0 && (
								<CredentialRatingEnrollmentBlock
									{...props}
									type={props.type}
									courseRating={props.courseRating}
									courseRatingCount={props.courseRatingCount}
									attendeeCount={props.attendeeCount}
								/>
							)}
						{((!props.loading &&
							props.evidences &&
							props.evidences.length > 0) ||
							props.earningCriteriaHTML) && (
							<CredentialEarningCriteriaBlock
								earningCriteriaHtml={props.earningCriteriaHTML}
								{...props}
							/>
						)}
						{!props.loading &&
							props.supportingDocumentationsWithMeta.length > 0 && (
								<CredentialSupportingDocumentationsBlock {...props} />
							)}
					</div>
				</div>
			</div>
		</div>
	);
};

export default withLocalize(CredentialWeb);
